<template>
  <svg
    id="svg34"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    :height="height"
    viewBox="0 0 1349.000000 212.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <metadata>Created by https://image.online-convert.com/convert-to-svg</metadata>
    <g id="g32" transform="translate(0.000000,212.000000) scale(0.100000,-0.100000)" stroke="1">
      <path
        id="path01-U"
        d="M112 1188 c4 -671 1 -638 75 -781 62 -117 184 -209 325 -242 37 -8 112 -15 178 -15 197 0 310 40 421 150 100 99 142 196 159 365 5 55 10 331 10
        613 l0 512 -135 0 -135 0 0 -552 c0 -429 -3 -564 -14 -603 -38 -145 -126 -214 -282 -223 -119 -6 -185 15 -249 81 -91 94 -89 76 -93 730 l-3 567 -130 0 -130 0 3 -602z"
        :fill="colorsComputed.start"
      />
      <path
        id="path02-D"
        d="M1730 975 l0 -817 338 4 c304 4 345 7 414 26 189 52 303 149 372 320 l31 77 3 361 c3 298 1 372 -12 427 -35 151 -131 276 -259 341 -133 67 -154 69
        -539 74 l-348 3 0 -816z m685 540 c106 -36 174 -109 195 -210 7 -34 10 -162 8 -357 -3 -294 -4 -305 -27 -355 -27 -61 -84 -116 -150 -147 -41 -19 -67 -21
        -243 -24 l-198 -4 0 563 0 562 183 -5 c135 -4 195 -10 232 -23z"
        :fill="colorsComputed.start"
      />
      <path
        id="path03-A"
        d="M3470 1038 c-156 -414 -294 -781 -306 -815 l-24 -63 144 0 144 0 53 155 54 155 316 0 315 0 53 -155 53 -155 145 0 c134 0 145 1 138 18 -3 9 -138
        368 -300 797 -161 429 -296 788 -300 798 -6 14 -21 17 -105 17 l-97 0 -283 -752z m493 14 c59 -169 107 -311 107 -315 0 -4 -99 -7 -221 -7 -173 0 -220 3
        -217 13 95 280 214 617 218 617 3 0 53 -139 113 -308z"
        :fill="colorsComputed.start"
      />
      <path
        id="path04-C"
        d="M5235 1795 c-212 -38 -358 -168 -421 -373 -26 -85 -37 -276 -31 -537 4 -208 9 -263 26 -328 54 -205 189 -344 383 -391 86 -21 244 -22 322 -1 193
        51 343 212 405 433 l20 72 -139 0 -139 0 -10 -35 c-39 -144 -168 -234 -320 -223 -82 6 -136 32 -190 94 -73 84 -81 128 -81 468 0 314 6 358 54 440 49 84
        132 128 243 128 59 0 84 -5 128 -26 66 -33 126 -98 156 -172 l23 -54 134 0 134 0 -7 38 c-4 20 -19 69 -34 108 -107 276 -357 414 -656 359z"
        :fill="colorsComputed.start"
      />
      <path
        id="path05-A"
        d="M6747 1783 c-6 -10 -598 -1583 -605 -1606 -4 -16 6 -17 139 -15 l144 3 37 110 c21 61 45 129 54 153 l16 42 315 -2 315 -3 52 -150 53 -150 141 -3
        c78 -1 142 1 142 5 0 5 -136 371 -302 815 l-303 808 -97 0 c-53 0 -99 -3 -101 -7z m211 -733 l110 -315 -109 -3 c-59 -1 -159 -1 -222 0 l-114 3 110 317 c61
        175 112 316 113 315 2 -1 52 -144 112 -317z"
        :fill="colorsComputed.start"
      />
      <path
        id="path06-P"
        d="M7900 976 l0 -816 135 0 135 0 0 314 0 313 238 6 c312 8 383 28 498 142 99 98 136 198 135 365 0 220 -105 381 -297 457 l-69 28 -387 3 -388 3 0
        -815z m760 534 c28 -16 55 -43 75 -74 28 -46 30 -56 30 -140 0 -102 -19 -152 -75 -199 -48 -41 -90 -47 -312 -47 l-208 0 0 246 0 246 223 -4 c215 -3 223 -4
        267 -28z"
        :fill="colorsComputed.start"
      />
      <path
        id="path07-I"
        d="M9420 975 l0 -815 135 0 135 0 0 815 0 815 -135 0 -135 0 0 -815z"
        :fill="colorsComputed.start"
      />
      <path
        id="path08-a"
        d="M10095 1756 c-78 -36 -83 -48 -36 -85 38 -30 40 -31 75 -16 19 8 58 15 86 15 64 0 100 -30 100 -85 l0 -35 -100 0 c-171 0 -225 -39 -225 -162 0
        -75 18 -109 74 -142 47 -27 153 -27 209 1 40 20 42 20 42 2 0 -17 8 -19 61 -19 l61 0 -4 208 c-4 225 -7 240 -65 293 -38 35 -83 49 -162 49 -48 0 -80 -7
        -116 -24z m225 -351 c0 -63 -8 -70 -86 -80 -35 -5 -61 -2 -87 9 -37 15 -38 17
        -35 58 4 55 28 68 131 68 l77 0 0 -55z"
        :fill="colorsComputed.start"
      />
      <path
        id="path09-a"
        d="M11010 1859 l0 -141 -31 26 c-38 32 -67 40 -130 34 -60 -6 -110 -48 -135 -113 -24 -65 -17 -295 12 -349 25 -50 58 -75 113 -87 58 -13 105 -2 141
        31 l30 28 0 -29 0 -29 65 0 65 0 0 385 0 385 -65 0 -65 0 0 -141z m-25 -213 c45 -45 48 -235 4 -282 -33 -35 -106 -34 -140 2 -21 23 -24 36 -27 120 -6 138
        20 184 101 184 27 0 45 -7 62 -24z"
        :fill="colorsComputed.start"
      />
      <path
        id="path10-m"
        d="M11410 1505 l0 -275 65 0 65 0 0 186 c0 114 4 193 11 206 15 27 71 49 108 42 16 -4 40 -17 53 -31 22 -24 23 -32 26 -214 l3 -189 60 0 59 0 1 168
        c1 92 1 170 0 175 -1 4 5 23 13 41 18 42 66 60 121 45 58 -16 65 -42 65 -249 l0 -180 67 0 66 0 -7 202 c-6 172 -10 208 -28 250 -50 116 -222 135 -292 32
        l-23 -34 -22 31 c-34 46 -79 69 -134 69 -54 0 -79 -10 -119 -48 l-28 -26 0 37 0 37 -65 0 -65 0 0 -275z"
        :fill="colorsComputed.start"
      />
      <path
        id="path11-i"
        d="M12460 1505 l0 -275 60 0 60 0 0 275 0 275 -60 0 -60 0 0 -275z"
        :fill="colorsComputed.start"
      />
      <path
        id="path12-idot"
        d="M12460 1935 l0 -65 60 0 60 0 0 65 0 65 -60 0 -60 0 0 -65z"
        :fill="colorsComputed.start"
      />
      <path
        id="path13-n"
        d="M12850 1505 l0 -275 60 0 60 0 0 175 c0 211 7 238 69 255 47 12 102 -5 120 -38 7 -13 11 -92 11 -206 l0 -186 66 0 66 0 -4 208 c-3 199 -4 209 -28
        251 -35 61 -68 83 -135 89 -63 5 -107 -9 -134 -44 l-19 -24 -6 35 -7 35 -59 0 -60 0 0 -275z"
        :fill="colorsComputed.start"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear" gradientUnits="userSpaceOnUse" x1="0" x2="218.442" y1="56.1386" y2="56.1386">
        <stop :stop-color="colorsComputed.end" />
        <stop :stop-color="colorsComputed.start" offset="1" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 18,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>
